import React, { useState, useEffect } from "react";
import styled from "styled-components";
import axios from "axios";
import { transformLocation } from "../../utils/locations";
import compact from "lodash/compact";
import BeachCard from "../BeachCard";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import heartIcon from "../../assets/heart_icon.png";
import heartWaves from "../../assets/heart.png";

document.body.style.background = "transparent";

const CARD_SIZE = 240;
const HEADER_HEIGHT = 40;
const MARGIN = 8;
const DOTS_BUFFER = 16;

const settings = {
  dots: true,
  infinite: true,
  slidesToScroll: 1,
  autoplay: true,
  speed: 1000,
  autoplaySpeed: 5000,
  cssEase: "ease-out",
  arrows: false
};

const Container = styled.div`
  height: ${CARD_SIZE + MARGIN * 2 + HEADER_HEIGHT + DOTS_BUFFER}px;
  width: ${CARD_SIZE + MARGIN * 2}px;
  border-radius: 10px;
  padding: ${MARGIN}px;
  background: #fedb97;
  background-image: url(${heartWaves});
  background-repeat: no-repeat;
  background-position: bottom left;

  .resultsCard {
    width: ${CARD_SIZE}px;
    height: ${CARD_SIZE}px !important;

    @media (orientation: portrait) {
      margin: 0px !important;
      min-height: 200px !important;

      .cardMedia {
        height: 140px;
      }
    }
  }

  .slick-dots {
    borderradius: 10px;
    paddinghorizontal: 10px;
    position: absolute;
    bottom: -${DOTS_BUFFER}px;

    li {
      margin: 0px;
      button::before {
        font-size: 10px;
      }
    }
  }
`;

const CardWrapper = styled.div`
  width: ${CARD_SIZE}px;
  height: ${CARD_SIZE}px;
  margin: ${MARGIN}px;
`;

const Header = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${HEADER_HEIGHT}px;
  cursor: pointer;
`;

const HeaderIcon = styled.img`
  width: ${HEADER_HEIGHT}px;
  height: ${HEADER_HEIGHT}px;
`;

const HeaderText = styled.h6`
  font-size: 20px;
  color: #0066ff;
  margin-left: ${MARGIN}px;
`;

const IFrame = () => {
  const [scale, setScale] = useState();
  const [locations, setLocations] = useState([]);

  const handleScaleParam = (scaleParam) => {
    try {
      if (scaleParam) {
        const newScale = Number(scaleParam) * 0.01;
        setScale(newScale);
      } else {
        setScale(1);
      }
    } catch (e) {
      setScale(1);
    }
  };

  const handleIdsParam = async (idsParam) => {
    const ids = JSON.parse(idsParam);
    const fetchedLocations = await Promise.all(
      ids.map(async (id) => {
        try {
          const response = await axios.get(`/locations/${id}`);
          return transformLocation(response.data);
        } catch (error) {
          return null;
        }
      })
    );
    setLocations(compact(fetchedLocations));
  };

  const handleParams = () => {
    try {
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);
      const scaleParam = searchParams.get("scale");
      handleScaleParam(scaleParam);
      const idsParam = searchParams.get("ids");
      handleIdsParam(idsParam);
    } catch (e) {}
  };

  useEffect(() => {
    handleParams();
  }, []);

  const renderCard = (location, index) => {
    const onClick = () => {
      const newTab = window.open(
        `${process.env.REACT_APP_PUBLIC_URL}/${location.latitude}/${location.longitude}/15/${location.id}`
      );
      newTab.focus();
    };

    return (
      <CardWrapper>
        <BeachCard
          key={`iframe_card_${index}`}
          beach={location}
          onClick={onClick}
        />
      </CardWrapper>
    );
  };

  const onHeaderClick = () => {
    const newTab = window.open(`${process.env.REACT_APP_PUBLIC_URL}`);
    newTab.focus();
  };

  if (!scale) {
    return null;
  }

  return (
    <Container
      style={{ transform: `scale(${scale})`, transformOrigin: "top left" }}>
      <Header onClick={onHeaderClick}>
        <HeaderIcon src={heartIcon} />
        <HeaderText>Beach Report Card</HeaderText>
      </Header>
      <Slider {...settings} style={{}}>
        {locations.map(renderCard)}
      </Slider>
    </Container>
  );
};

export default IFrame;



// WEBPACK FOOTER //
// ./src/components/IFrame/index.js